namespace RecordShield.Workspace {
    export interface SerialKeyDetailsRetrieveRequest extends Serenity.RetrieveRequest {
        SerialKeyId?: number;
    }
}
